"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "20",
    height: "16",
    viewBox: "0 0 20 16"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: props.fill,
    fillRule: "evenodd",
    d: "M7.001,7.41 L6.746,6.39 C6.58733254,5.83466389 6.43433407,5.24533645 6.287,4.622 C6.13966593,3.99866355 5.99233407,3.39800289 5.845,2.82 L5.777,2.82 C5.64099932,3.40933628 5.50216738,4.01283025 5.3605,4.6305 C5.21883263,5.24816976 5.06866746,5.83466389 4.91,6.39 L4.638,7.41 L7.001,7.41 Z M9.59507331,8.01152841 L7.66086702,9.9457347 L7.511,9.365 L4.128,9.365 L3.448,12 L0.898,12 L4.366,0.916 L7.375,0.916 L9.59507331,8.01152841 L9.59507331,8.01152841 Z M6,13.3413234 L13.8413234,5.5 L16.5,8.15867657 L8.65867657,16 L6,16 L6,13.3413234 Z M19.7675607,5.21243082 L18.3133248,6.66666667 L15.3333333,3.68667518 L16.7875692,2.23243934 C17.0974883,1.92252022 17.5981269,1.92252022 17.908046,2.23243934 L19.7675607,4.09195402 C20.0774798,4.40187314 20.0774798,4.90251171 19.7675607,5.21243082 Z"
  }));
};

exports["default"] = _default;